import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

type Props = {
    onSave: () => void;
    onReset: () => void;
    isSaveDisabled: boolean;
    isResetDisabled: boolean;
    isSaving: boolean;
    saveLabelKey: string;
    resetLabelKey: string;
    dataAutomationPrefix: string;
};

/** Sticky save/reset bar shared by the editable team detail tabs. */
export const TeamDetailTabFooter = ({
    onSave,
    onReset,
    isSaveDisabled,
    isResetDisabled,
    isSaving,
    saveLabelKey,
    resetLabelKey,
    dataAutomationPrefix,
}: Props) => {
    const { translate } = useTranslate();

    return (
        <Flex
            background={colorsPalettes.carbon[0]}
            borderTop={`1px solid ${colorsPalettes.carbon[100]}`}
            position="sticky"
            bottom="0"
            zIndex={1}
            padding="16px"
            justifyContent="flex-end"
            gap="8px"
            data-automation={`${dataAutomationPrefix}-footer`}
        >
            <Button
                type="flat"
                isDisabled={isResetDisabled}
                onClick={onReset}
                dataAutomation={`${dataAutomationPrefix}-reset-button`}
            >
                {translate(resetLabelKey)}
            </Button>
            <Button
                type="primary"
                isDisabled={isSaveDisabled}
                isLoading={isSaving}
                onClick={onSave}
                dataAutomation={`${dataAutomationPrefix}-save-button`}
            >
                {translate(saveLabelKey)}
            </Button>
        </Flex>
    );
};
